import { max, min } from './math.js';

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

export { within, withinMaxClamp };
//# sourceMappingURL=within.js.map
